import { type AppLocale, resolveLocale } from '@echo/i18n';

const STORAGE_KEY = 'echo.locale';
const QUERY_PARAM = 'lang';

/**
 * Where the browser's language comes from, in priority order: `?lang=` (support links, QA —
 * for this visit only), the person's saved choice, then the browser's languages. The saved
 * choice is per browser until OnEarly stores a language on the account (docs/i18n.md).
 */
export function detectLocale(allowPseudo: boolean): AppLocale {
  const fromUrl = new URLSearchParams(window.location.search).get(QUERY_PARAM);
  return resolveLocale([fromUrl, readStoredLocale(), ...navigator.languages], { allowPseudo });
}

export function readStoredLocale(): string | undefined {
  try {
    return window.localStorage.getItem(STORAGE_KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

export function storeLocale(locale: AppLocale): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // Storage can be unavailable (private mode, blocked site data); the choice then lasts the visit.
  }
}

/** Screen readers, hyphenation and `:lang()` all key off `<html lang>`. */
export function applyDocumentLocale(locale: AppLocale): void {
  document.documentElement.lang = locale;
}
